/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_PRESENTATION_LISTS: {},
};

const MACHINE_CONFIG = {
  id: "io.vlinder.gems.printLabel.getPresentationLists",
  initial: "idle",
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ["resetAction"],
      on: {
        START: { target: "GET_PRESENTATION_LISTS" },
      },
    },
    GET_PRESENTATION_LISTS: {
      invoke: {
        id: "getPresentationLists",
        src: "getPresentationLists",
        onDone: {
          target: "GET_PRESENTATION_LISTS_SUCCESS",
          actions: ["successAction"],
        },
        onError: {
          target: "GET_PRESENTATION_LISTS_FAILED",
          actions: ["failureAction"],
        },
      },
    },
    GET_PRESENTATION_LISTS_SUCCESS: {
      on: {
        START: { target: "GET_PRESENTATION_LISTS" },
      },
    },
    GET_PRESENTATION_LISTS_FAILED: {
      on: {
        START: { target: "GET_PRESENTATION_LISTS" },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
